import { render, staticRenderFns } from "./sch_baoxian.vue?vue&type=template&id=fb231df6&scoped=true"
import script from "./sch_baoxian.vue?vue&type=script&lang=js"
export * from "./sch_baoxian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb231df6",
  null
  
)

export default component.exports